var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F8BA47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38C18.9688 38 14.375 35.375 11.8594 31C9.34375 26.6797 9.34375 21.375 11.8594 17C14.375 12.6797 18.9688 10 24 10C28.9766 10 33.5703 12.6797 36.0859 17C38.6016 21.375 38.6016 26.6797 36.0859 31C33.5703 35.375 28.9766 38 24 38ZM24 17C23.2344 17 22.6875 17.6016 22.6875 18.3125V24.4375C22.6875 25.2031 23.2344 25.75 24 25.75C24.7109 25.75 25.3125 25.2031 25.3125 24.4375V18.3125C25.3125 17.6016 24.7109 17 24 17ZM22.25 29.25C22.25 30.2344 23.0156 31 24 31C24.9297 31 25.75 30.2344 25.75 29.25C25.75 28.3203 24.9297 27.5 24 27.5C23.0156 27.5 22.25 28.3203 22.25 29.25Z",
    fill: "#584215"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusError);
export default __webpack_public_path__ + "static/media/status-error.34359f06a41f0a04c22e2c58ca4f886f.svg";
export { ForwardRef as ReactComponent };